import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { maintenanceConfig } from '../config/maintenance';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

export function MaintenanceWrapper({ children }: MaintenanceWrapperProps) {
  const location = useLocation();
  
  if (maintenanceConfig.isMaintenanceMode && !maintenanceConfig.allowedPaths.includes(location.pathname)) {
    return <Navigate to="/coming-soon" replace />;
  }

  return <>{children}</>;
} 